export default __webpack_public_path__ + "static/project-slide-3-992-765-572dbe356098fca380d7d458736dfb0a.webp";